import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { Image } from 'components/Image/Image';
import { useConfig } from 'hook/config.hook';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { AUTO_REFINANCE } from 'types/morph.pagePosition.constants';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { autoRefinanceOfferHowIsCalculatedTooltip } from 'helpers/offer.helpers';
import SeeAll from 'components/SeeAllButton/index';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { Link } from 'components/navigation/Link/Link';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const AutoRefinanceTemplate = props => {
  const {
    clickDetailsHandler,
    currentLoanDetails,
    offerMetadata,
    seenPixel,
    onClickSeeAllOptions,
  } = props;

  const { config } = useConfig();
  const overViewAutoLoanHowCalculated =
    config?.disclaimers?.autoLoans?.overviewAutoLoanHowIsThisCalculated;
  const autoLoanSectionTooltip = autoRefinanceOfferHowIsCalculatedTooltip(
    overViewAutoLoanHowCalculated,
    offerMetadata,
  );

  return (
    <>
      {seenPixel}
      <FlexContainer
        className={
          'flex-container system_neutral_n000 grayShadow16 margt12 border-rad8px padT40 padB48 m-padT20 m-padT24 m-margb0'
        }
      >
        <Row className={'format100'}>
          <FlexContainer className={'flex-column'}>
            <FlexContainer className={'justify-between format100'}>
              <FlexContainer
                className={'align-self-center m-hide t-hide margt10'}
              >
                <Image className={'autoRefinanceIcon'} />
              </FlexContainer>
              <FlexContainer className={'flex-column format50 m-format100'}>
                <Label className="text-18 m-text-16 bold system_neutral_n400_text">
                  {'We found savings for you!'}
                </Label>
                <Label
                  type="Body-2"
                  className={'text-14 margtb10 system_neutral_n400_text'}
                >
                  If you refinance, You could{' '}
                  <span className="bold">
                    save up to ${offerMetadata?.averagePaymentSavings}/mo
                  </span>{' '}
                  on your {currentLoanDetails?.name} loan.
                </Label>
                <Label type="Body-2" className={'text-14 margtb10'}>
                  <FlexContainer className={'items-align-baseline'}>
                    <CSTooltip
                      removeMarginsMobile
                      isInline={true}
                      placement={'bottom'}
                      pagePosition={AUTO_REFINANCE}
                      tooltipContent={autoLoanSectionTooltip}
                      tooltipName="How is this calculated"
                      overlayClassName="annualIncomeCSTooltip"
                      vertical={AUTO_LOAN_VERTICAL}
                    >
                      <span className="secondary_text_light pointer">
                        How is this calculated? |
                      </span>
                    </CSTooltip>
                    <Link
                      linkClassName="secondary_text_light pointer margL4"
                      ariaLabel="See all options"
                      onClickCallback={() =>
                        onClickSeeAllOptions(offerMetadata?.productKey)
                      }
                    >
                      See all options
                    </Link>
                  </FlexContainer>
                </Label>
              </FlexContainer>
              <FlexContainer
                className={'align-self-center margt10 m-margt20 m-hide t-hide'}
              >
                <Button
                  mrphType="primary"
                  onClick={clickDetailsHandler}
                  className="border-rad100px"
                >
                  <Label
                    type="Subtitle-2"
                    color="primary_cta_text_light"
                    className={'text-16 m-text-14 padlr30'}
                    tabIndex="-1"
                  >
                    {'View Offer'}
                  </Label>
                </Button>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className={'justify-between d-hide'}>
              <Image imgClass={'autoRefinanceIcon'} />
              <FlexContainer className={'align-self-center margt10 m-margt10'}>
                <Button
                  mrphType="primary"
                  onClick={clickDetailsHandler}
                  className="border-rad100px"
                >
                  <Label
                    type="Subtitle-2"
                    color="primary_cta_text_light"
                    className={'text-16 m-text-14 padlr30'}
                  >
                    {'View Offer'}
                  </Label>
                </Button>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </Row>
      </FlexContainer>
    </>
  );
};

const AutoRefinanceModuleView = props => {
  const { offers, config, onClickSeeAllOptions } = props;
  const offer = offers[0];
  const toAutoLoanPage = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'To Auto Loan offers',
    });
    onClickSeeAllOptions(offer?.productKey);
  };
  return (
    offer?.averagePaymentSavings > 0 && (
      <FlexContainer className={'flex-column'}>
        <FlexContainer className={'justify-between align-baseline'}>
          <Label
            type="H4"
            typeHeader={'h2'}
            className={'margB0 m-text-12 system_neutral_n500_text'}
          >
            Auto loans for your profile
          </Label>
          <SeeAll
            onClick={toAutoLoanPage}
            className={
              'm-margT6 text-12 m-text-12 align-baseline secondary_text_light'
            }
          />
        </FlexContainer>
        {config?.showDisclaimerInOffers && (
          <Disclaimer showPartnerText className="margT10 margB6" />
        )}
        <StaticOfferContainer
          offerMetadataList={[offer]}
          autoLoanTemplate={AutoRefinanceTemplate}
          onClickSeeAllOptions={onClickSeeAllOptions}
          pagePosition={props.pagePosition}
          modulePosition={props.modulePosition}
          eventHandler={props.eventHandler}
        />
      </FlexContainer>
    )
  );
};

export default AutoRefinanceModuleView;
